import React, { useState } from 'react';
import { Card } from './ui/card';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Badge } from './ui/badge';
import { contactInfo } from '../mockData';
import { MapPin, Mail } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

export const Contact = () => {
  return (
    <section id="contact" className="section-padding">
      <div className="container">
        <div className="section-header">
          <Badge className="section-badge">Contattaci</Badge>
          <h2 className="section-title">Vieni a Trovarci</h2>
          <p className="section-description">
            Siamo a Reggio nell'Emilia, pronti a servirti con professionalità
          </p>
        </div>

        <div className="contact-wrapper">
          <div className="contact-info-section">
            <Card className="contact-info-card">
              <h3 className="contact-card-title">Informazioni Negozio</h3>
              
              <div className="contact-info-item">
                <div className="contact-icon-wrapper contact-icon-cyan">
                  <MapPin className="w-5 h-5" />
                </div>
                <div>
                  <p className="contact-label">Indirizzo</p>
                  <a 
                    href="https://maps.google.com/?q=Piazza+Gioberti+4B+Via+Emilia+Santo+Stefano+22E+Reggio+Emilia"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-value contact-link"
                  >
                    {contactInfo.address}
                  </a>
                  <p className="contact-value-secondary">{contactInfo.province}</p>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-icon-wrapper contact-icon-amber">
                  <Mail className="w-5 h-5" />
                </div>
                <div>
                  <p className="contact-label">Email</p>
                  <p className="contact-value">{contactInfo.email}</p>
                </div>
              </div>
            </Card>

            <div className="contact-map">
              <iframe
                title="Mappa Tabaccheria N.16"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2831.4!2d10.6316!3d44.6978!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477e35c9f5b3e3a1%3A0x8e67414c0ccf7bd1!2sPiazza%20Gioberti%2C%204%2C%2042121%20Reggio%20Emilia%20RE!5e0!3m2!1sit!2sit!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0, borderRadius: '12px' }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
